import CommunityIntegrations from './CommunityIntegrations'

export default CommunityIntegrations;
